module.exports = __webpack_public_path__ + "img/smoker-selected.5e52eb18.svg";